var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.data !== '')?_c('span',[_vm._v(" "+_vm._s(this.data)+" ")]):_c('em',[_vm._v(" 空 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }